var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FAAD19",
    style: {
      boxShadow: "0 2px 40px 0 rgba(0,0,0,.201)"
    },
    transform: "rotate(90 16 16)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23 17h-6v6h-2v-6H9v-2h6V9h2v6h6z"
  })));
};
export default SvgAdd;